import { render, staticRenderFns } from "./ProcessInstanceScreen.vue?vue&type=template&id=3e9133e2&scoped=true"
import script from "./ProcessInstanceScreen.vue?vue&type=script&lang=js"
export * from "./ProcessInstanceScreen.vue?vue&type=script&lang=js"
import style0 from "./ProcessInstanceScreen.vue?vue&type=style&index=0&id=3e9133e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9133e2",
  null
  
)

export default component.exports